export default "__VITE_ASSET__DbX5ZGDN__"